import Box from "@material-ui/core/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadShopData } from "../actions/shopLoadData";
import { IP } from "../config/IP";
import CategotyTabs from "./ShopCategory";
import "./ShopManagmentScreen.css";
import { LeftSideScreen } from "./SideScreen";
import PrimarySearchAppBar from "./TopToolBar";

const InventoryManagementApp = () => {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const notitifcationRef = React.useRef(null);
	React.useEffect(() => {
		if (state.shopSaveInfo.isSave) {
			let inputs = {
				url: IP.nodeServer + "api/loadShopData",
				method: "POST",
				data: [{ name: "categoryName", value: "ok" }],
			};
			console.log("loadShopData");
			dispatch(loadShopData(inputs));
		}
	}, [state.shopSaveInfo.isSave]);

	return (
		<div className="container">
			<LeftSideScreen />

			<section id="contents">
				<PrimarySearchAppBar ref={notitifcationRef} />
				<Box color="text.primary" clone>
					<CategotyTabs />
				</Box>
			</section>
		</div>
	);
};
export default InventoryManagementApp;
